import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { providePrimeNG } from 'primeng/config';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { KnobModule } from 'primeng/knob';
import { MenubarModule } from 'primeng/menubar';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import Aura from '@primeng/themes/aura';
import Material from '@primeng/themes/material';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';

import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { AppRoutingModule } from './app/app-routing.module';
import { SiloLevelsService } from './app/team/widgets/silolevels/silolevels.service';
import { TableDataService } from './app/team/table/table.service';
import { SchedulingService } from './app/team/scheduling/scheduling.service';
import { QueryService } from './app/team/query/query.service';
import { RemittanceRebuilderService } from './app/team/settings/remittance-rebuilder/remittance-rebuilder.service';
import { CultivarService } from './app/team/settings/cultivars/cultivars.service';
import { StorageService } from './app/team/settings/storage/storage.service';
import { EmailSettingsService } from './app/team/settings/email/email.service';
import { BankAccountsService } from './app/team/settings/bankaccounts/bankaccounts.service';
import { GeneralSettingsService } from './app/team/settings/general/general.service';
import { SeasonalSettingsService } from './app/team/settings/seasonal/seasonal.service';
import { PriceModelService } from './app/team/settings/pricemodel/pricemodel.service';
import { SettingsUsersService } from './app/team/settings/users/users.service';
import { SettingsClientsService } from './app/team/settings/clients/clients.service';
import { DepotDeliveryService } from './app/team/depot/depotdelivery.service';
import { SiloSelectorService } from './app/team/silo-selector/silo-selector.service';
import { SiloService } from './app/team/overview/silos/silos.service';
import { AddOrderService } from './app/team/logging/add-order/add-order.service';
import { RecoverPalletService } from './app/team/overview/recoverpallet/recoverpallet.service';
import { StockRecallService } from './app/team/traceability/stockrecall/stockrecall.service';
import { TracePackingService } from './app/team/traceability/tracepackinglist/tracepackinglist.service';
import { TraceInventoryService } from './app/team/traceability/traceinventory/traceinventory.service';
import { TraceabilityService } from './app/team/traceability/traceability.service';
import { TeamQRService } from './app/team/qr/qr.service';
import { TeamRemittancesService } from './app/team/overview/remittances/teamremittances.service';
import { InventoryService } from './app/team/overview/inventory/inventory.service';
import { BatchesService } from './app/team/overview/batches/batches.service';
import { CurrencyService } from './app/team/overview/currency/currency.service';
import { ProcessingService } from './app/team/overview/processing/processing.service';
import { AddMsggroupService } from './app/team/messages/add-msggroup/add-msggroup.service';
import { AddArticleService } from './app/team/messages/add-article/add-article.service';
import { AddBookingService } from './app/team/logging/add-booking/add-booking.service';
import { AddCurrencyService } from './app/team/logging/add-currency/add-currency.service';
import { AddProcessingService } from './app/team/logging/add-processing/add-processing.service';
import { AddPaymentService } from './app/team/logging/add-payment/add-payment.service';
import { AddPalletSampleService } from './app/team/logging/add-palletsample/add-palletsample.service';
import { AddSampleBatchedService } from './app/team/logging/add-sample-batched/add-sample.service';
import { AddDeliveryService } from './app/team/logging/add-delivery/add-delivery.service';
import { AddCompanyService } from './app/team/logging/add-company/add-company.service';
import { AddContactService } from './app/team/logging/add-contact/add-contact.service';
import { RemittanceService } from './app/team/overview/remittance/remittance.service';
import { CountryService } from './app/services/countries.service';
import { SplitTermsService } from './app/services/splitterms.service';
import { DropDownDataService } from './app/team/logging/dropdown.service';
import { TeamCalculatorService } from './app/team/calculator/teamcalculator.service';
import { TeamHeaderService } from './app/team/header/teamheader.service';
import { TeamResetService } from './app/team/auth/reset/reset.service';
import { TeamLoginService } from './app/team/auth/login/teamlogin.service';
import { TeamAuthGuard } from './app/team/teamauth-guard.service';
import { BuyingTableDataService } from './app/buying/table/table.service';
import { BuyingHeaderService } from './app/buying/header/header.service';
import { BuyingResetService } from './app/buying/auth/reset/reset.service';
import { BuyingLoginService } from './app/buying/auth/login/login.service';
import { BuyingAuthGuard } from './app/buying/buyingauth-guard.service';
import { LogisticsQRService } from './app/logistics/qr/qr.service';
import { LogisticsTableDataService } from './app/logistics/table/table.service';
import { LogisticsHeaderService } from './app/logistics/header/header.service';
import { LogisticsResetService } from './app/logistics/auth/reset/reset.service';
import { LogisticsLoginService } from './app/logistics/auth/login/login.service';
import { LogisticsAuthGuard } from './app/logistics/logisticsauth-guard.service';
import { ClientTableDataService } from './app/client/table/table.service';
import { CalculatorService } from './app/client/calculator/calculator.service';
import { FarmerInvoiceSelectorService } from './app/client/invoiceselector/invoiceselector.service';
import { FarmerFinanceQuoteService } from './app/client/financequote/financequote.service';
import { FarmerRemittanceService } from './app/client/remittance/remittance.service';
import { ClientDeliveryService } from './app/client/delivery/delivery.service';
import { ArticleService } from './app/client/article/article.service';
import { AnnouncementService } from './app/client/announcement/announcement.service';
import { HeaderService } from './app/client/header/header.service';
import { AuthGuard } from './app/auth-guard.service';
import { ResetService } from './app/client/auth/reset/reset.service';
import { TeamAuthService } from './app/team/auth/auth.service';
import { LoginService } from './app/client/auth/login/login.service';
import { ForwardFinanceService } from './app/services/forwardfinance.service';
import { FilesService } from './app/services/files.service';
import { BaseQRService } from './app/services/qr.service';
import { CsvService } from './app/services/csv.service';
import { PortalService } from './app/auth/portal.service';
import { SearchService } from './app/search.service';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule, 
            BrowserAnimationsModule,
            AppRoutingModule,
            ReactiveFormsModule, 
            FormsModule, 
            MatSliderModule, 
            MatSlideToggleModule, 
            MatCheckboxModule, 
            MatCardModule, 
            MatFormFieldModule, 
            MatInputModule, 
            MatTableModule, 
            MatSortModule, 
            MatProgressSpinnerModule, 
            MatSelectModule, 
            MatIconModule, 
            MatButtonModule, 
            MatDatepickerModule, 
            MatNativeDateModule, 
            MomentDateModule, 
            ZXingScannerModule, 
            TableModule, 
            ButtonModule, 
            InputTextModule, 
            DropdownModule, 
            ToastModule, 
            ConfirmDialogModule, 
            FullCalendarModule, 
            MenubarModule, 
            FileUploadModule, 
            NgxMatTimepickerModule, 
            DynamicDialogModule, 
            TabViewModule, 
            KnobModule
        ),
        SearchService,
        PortalService,
        CsvService,
        BaseQRService,
        FilesService,
        ForwardFinanceService,
        LoginService,
        TeamAuthService,
        ResetService,
        AuthGuard,
        HeaderService,
        AnnouncementService,
        ArticleService,
        ClientDeliveryService,
        FarmerRemittanceService,
        FarmerFinanceQuoteService,
        FarmerInvoiceSelectorService,
        CalculatorService,
        ClientTableDataService,
        LogisticsAuthGuard,
        LogisticsLoginService,
        LogisticsResetService,
        LogisticsHeaderService,
        LogisticsTableDataService,
        //LogisticsAddContactService,
        //LogisticsAddCompanyService,
        //LogisticsAddOrderService,
        LogisticsQRService,
        BuyingAuthGuard,
        BuyingLoginService,
        BuyingResetService,
        BuyingHeaderService,
        BuyingTableDataService,
        TeamAuthGuard,
        TeamLoginService,
        TeamResetService,
        TeamHeaderService,
        TeamCalculatorService,
        DropDownDataService,
        SplitTermsService,
        CountryService,
        RemittanceService,
        AddContactService,
        AddCompanyService,
        AddDeliveryService,
        AddSampleBatchedService,
        AddPalletSampleService,
        AddPaymentService,
        AddProcessingService,
        AddCurrencyService,
        AddBookingService,
        AddArticleService,
        AddMsggroupService,
        ProcessingService,
        CurrencyService,
        BatchesService,
        InventoryService,
        TeamRemittancesService,
        TeamQRService,
        TraceabilityService,
        TraceInventoryService,
        TracePackingService,
        StockRecallService,
        RecoverPalletService,
        AddOrderService,
        SiloService,
        SiloSelectorService,
        DepotDeliveryService,
        SettingsClientsService,
        SettingsUsersService,
        PriceModelService,
        SeasonalSettingsService,
        GeneralSettingsService,
        BankAccountsService,
        EmailSettingsService,
        StorageService,
        CultivarService,
        RemittanceRebuilderService,
        QueryService,
        SchedulingService,
        TableDataService,
        MessageService,
        ConfirmationService,
        SiloLevelsService,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Material } }),
    ]
})
  .catch(err => console.error(err));
